import { render, staticRenderFns } from "./DiscountRow.vue?vue&type=template&id=48f08dea&scoped=true"
import script from "./DiscountRow.vue?vue&type=script&lang=js"
export * from "./DiscountRow.vue?vue&type=script&lang=js"
import style0 from "./DiscountRow.vue?vue&type=style&index=0&id=48f08dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f08dea",
  null
  
)

export default component.exports